import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import { rejectError } from 'common/_redux';

import { AxiosError } from 'axios';
import BasicModal from '../modals/BasicModal';
import DefaultButton from '../DefaultButton';

const ErrorHandler = ({ children, rejectError, hasErrors, redirect, error }) => {
  const history = useHistory();

  let captionId = 'somethingWentWrongCaption';
  let description = '';
  let descriptionId = 'somethingWentWrongDescription';

  if (typeof error === 'string') {
    captionId = null;
    description = error;
  } else if (error instanceof AxiosError) {
    if (error?.response?.status === 403) {
      captionId = null;
      descriptionId = 'missingOneOfRequiredPermissions';
    }
  }

  return (
    <>
      {children}
      <BasicModal
        onRequestClose={rejectError}
        isOpen={hasErrors}
        captionId={captionId}
        description={description}
        descriptionId={descriptionId}
        overlayClassName="Modal_error-overlay">
        <DefaultButton
          textId="justClose"
          onClick={() => {
            rejectError();
            if (redirect) {
              history.push(redirect);
            }
          }}
        />
      </BasicModal>
    </>
  );
};

ErrorHandler.propTypes = {
  hasErrors: PropTypes.bool.isRequired,
  rejectError: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  redirect: PropTypes.string,
  error: PropTypes.string,
};

ErrorHandler.defaultProps = {
  redirect: null,
  error: '',
};

export default connect(
  ({ common: { globalError, hasErrors, redirect } }) => ({ error: globalError, hasErrors, redirect }),
  {
    rejectError,
  }
)(ErrorHandler);
export { ErrorHandler };
